import CustomModal from "components/CustomModal";
import React from "react";
import { useTranslation } from "react-i18next";
// import "./style.scss";

import SelectLabel from "./SelectLabel";
import { useDispatch, useSelector } from "react-redux";

function ManagerLabelModal({
  open,
  setOpen,
  projects,
  curProject,
  isProjectGroupPage = true, // true: đang ở view project group page, khi xóa sẽ cập nhật các label trong projects
  handleRemove = (val) => {},
  handleUpdate = (val) => {},
}) {
  const { t } = useTranslation();
  const [data, setData] = React.useState([]);
  const labelsProject = useSelector(
    ({ projectLabels }) => projectLabels.listProjectLabels
  );
  React.useEffect(() => {
    const _getData = async () => {
      console.log(labelsProject.data?.projectLabels);
      setData(labelsProject.data?.projectLabels);
    };

    _getData();
  }, [labelsProject]);
  // const _getValue = () => {
  //   console.log(refOptions.current._getValue());
  // };

  const refOptions = React.useRef(null);

  // const [activeLoading, setActiveLoading] = React.useState(false);

  return (
    <CustomModal
      title={t("MANAGER_LABEL")}
      open={open}
      setOpen={setOpen}
      canConfirm={false}
      // onConfirm={() => {
      //   _getValue();
      //   // setActiveLoading(true);
      // }}
      onCancle={() => {
        // setData(refOptions.current._getValue());
        setOpen(false);
        // console.log(refOptions.current._getValue());
      }}
      // activeLoading={activeLoading}
      manualClose={true}
      height={"mini"}
      maxWidth={"sm"}
      confirmRender={null}
      className=""
    >
      <SelectLabel
        ref={refOptions}
        isEditForm={true}
        defaultSelect={data}
        projects={projects ?? []} // chỉ cần khi isProjectGroupPage = true
        curProject={curProject}
        isProjectGroupPage={isProjectGroupPage}
        handleRemove={handleRemove}
        handleUpdate={handleUpdate}
      />
    </CustomModal>
  );
}

export default ManagerLabelModal;
